// extracted by mini-css-extract-plugin
export default {"card":"Aside_card__olNOX"};